import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TranslationText from '@Components/Utilities/TranslationText';

const RequestAQuoteBanner = ({ handleRequestAQuoteBannerClick }) => {
    return (
        <Box sx={{
            background: '#000 url(../Content/RentalYard/bg-quote.jpg) center center no-repeat',
            backgroundSize: 'cover',
            padding: '50px 0',
            color: '#fff',
            display: 'flex',
            justifyContent: 'center'
        }} className="quote-section">
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px 35px',
                padding: '0px 20px',
                width: '1140px'
            }} className="container" >
                <Box sx={{
                    fontSize: '26px',
                    fontStyle: 'italic',
                    flex: 1,
                    textTransform: 'capitalize',
                }} component="h2">
                    <TranslationText tKey='sandhills.lookingtorent' />
                </Box>
                <Button sx={{
                    background: '#fff',
                    width: '100%',
                    maxWidth: '225px',
                    marginLeft: 'auto',
                    fontSize: '16px',
                    color: '#1E74A9',
                    '&:hover': {
                        backgroundColor: '#fff',
                        color: '#1E74A9'
                    }
                }} variant="contained" color="primary" onClick={handleRequestAQuoteBannerClick}>
                    <TranslationText tKey='sandhills.requestaquote' />
                </Button>
            </Box>
        </Box>
    );
};

export default RequestAQuoteBanner;